var React = require('react');

function EditInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.526 12.957L.89 15.08l2.196-5.595L11.862.711a1 1 0 0 1 1.418.003l2.03 2.05a1 1 0 0 1-.003 1.412l-8.781 8.781zm-.803-.803L3.89 10.288l-.976 2.825 2.809-.959z","fill":"currentColor","fillRule":"evenodd"}));
}

EditInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = EditInline;

EditInline.default = EditInline;
